import { getUrlKeys } from '@/utils/index'
import RequestService from '@/utils/service'
import router from './router'
import area from '@/area'
import store from './store'

// 先判断有没 code
// 没有 code 的话直接跳转到微信授权获取 code
router.beforeEach((to, from, next) => {
  // 旧版兼容
  const oldVersionRoomId = '1265105989309304833'
  if (getUrlKeys('roomId') && getUrlKeys('roomId') === oldVersionRoomId) {
    return window.location.replace(window.location.origin + window.location.pathname + 'room/' + oldVersionRoomId)
  }

  // 如果是站内跳转、不处理下面流程
  if (store.state.user.id) return next()

  // 如果有 token就拿 token 登录、没有则拿 token 去授权
  const token = localStorage.getItem('v2-token')

  if (token) {
    RequestService({ url: '/member/info', data: {}}).then(userRes => {
      store.dispatch('initUser', userRes.result)
      next()
    })
  } else {
    const env = process.env.NODE_ENV
    const code = getUrlKeys('code')

    if (!code) {
      if (env === 'development') {
        window.location.replace(window.location.origin + window.location.pathname + '?code=kunsect')
      } else {
        window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + area.appId + '&redirect_uri='
          + encodeURIComponent(window.location.origin + window.location.pathname)
          + '&response_type=code&scope=snsapi_userinfo&state=STATE'
          + (area.componentAppId ? '&component_appid=' + area.componentAppId : '')
          + '#wechat_redirect')
      }

      return
    }

    RequestService({ url: '/paltform/wx/mp/auth/authLogin', data: { appid: area.appId, code: code }}).then(userRes => {
      localStorage.setItem('v2-token', userRes.result.token)
      store.dispatch('initUser', userRes.result.memberDetail)
      next()
    })
  }
})
